import $ from 'jquery';
import Swiper, { Lazy, Navigation, Scrollbar } from 'swiper';
import { AdaSupport } from '../../components/modules/ada-support';

const tabButtonEl = '.tacc__tabs-button ';
const tabCaptionEl = '.tacc__tab-caption';
const tabCaptionInnerEl = '.tacc__tab-caption-inner';
const tabContentAllEl = '.tacc__tab-content';
const tabCarouselAllEl = '.tacc__tab-carousel';
const tabSwiperEl = '.tacc__tab-swiper';
const moreOuterEl = '.tacc__more-outer';
const moreEl = '.tacc__more';

/**
 * slide preloader class
 * @type {string}
 */
const slidePreloaderClass = 'c-slide-preloader';

/**
 * undefined, 1 - mouse click, mobile device tap
 * 13 - keyboard enter code
 * 32 - keyboard space code
 * @type {*[]}
 */
const keyCodesAvailable = [undefined, 1, 13, 32];

const swipers = [];

function tabElementHide(element) {
  $(element).hide().removeAttr('style').removeClass('active');
}

function tabElementShow(element) {
  $(element).show().addClass('active').animate({ opacity: 1 }, 700);
}

/**
 * @param caption
 * @param captionInner
 * @param captionMoreButton
 */
function captionMore(caption, captionInner, captionMoreButton) {
  const readMoreAllEl = '.tacc__more-outer';

  $(readMoreAllEl).removeClass('show');

  if (caption.height() < captionInner.height() - 30) {
    captionMoreButton.addClass('show');
  }
}

/**
 * @param carousel
 * @param prev
 * @param next
 * @param scrollbar
 * @returns {boolean}
 */
function initCarousel(carousel, prev, next, scrollbar) {
  if (!$(carousel).find(tabSwiperEl)[0]) {
    return false;
  }

  const swiper = new Swiper($(carousel).find($(tabSwiperEl))[0], {
    loop: false,
    init: false,
    slidesPerView: 3,
    speed: 700,
    modules: [Lazy, Navigation, Scrollbar],
    lazy: {
      loadPrevNext: true,
      preloaderClass: slidePreloaderClass,
      preloadImages: false,
    },
    navigation: {
      prevEl: prev,
      nextEl: next,
    },
    scrollbar: {
      el: scrollbar,
      hide: false,
    },
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
  });

  swiper.init();
  swipers.push(swiper);

  return true;
}

$(window).on('load', () => {
  const contentEl = `#${$(tabButtonEl).first().data('tab')}`;
  const carouselEl = `#${$(tabButtonEl).first().data('carousel')}`;
  const btnPrevEl = `#${$(tabButtonEl).first().data('prev')}`;
  const btnNextEl = `#${$(tabButtonEl).first().data('next')}`;
  const scrollEl = `#${$(tabButtonEl).first().data('scroll')}`;

  $(tabButtonEl).first().addClass('active');

  tabElementShow(contentEl);
  tabElementShow(carouselEl);

  captionMore(
    $(contentEl).find($(tabCaptionEl)),
    $(contentEl).find($(tabCaptionInnerEl)),
    $(contentEl).find($(moreOuterEl)),
  );

  initCarousel(carouselEl, btnPrevEl, btnNextEl, scrollEl);
});

$(document).on('click tap keyup', tabButtonEl, (event) => {
  if (keyCodesAvailable.indexOf(event.keyCode) === -1) {
    return false;
  }

  const contentEl = `#${$(event.target).data('tab')}`;
  const carouselEl = `#${$(event.target).data('carousel')}`;
  const btnPrevEl = `#${$(event.target).data('prev')}`;
  const btnNextEl = `#${$(event.target).data('next')}`;
  const scrollEl = `#${$(event.target).data('scroll')}`;

  swipers.forEach((element) => {
    element.destroy();
  });

  $(tabButtonEl).removeClass('active');
  $(tabContentAllEl).hide().removeAttr('style').removeClass('active');
  $(event.target).addClass('active');
  $(tabCaptionEl).removeClass('open');

  $(contentEl).addClass('active');
  $(carouselEl).addClass('active');

  tabElementHide(tabCarouselAllEl);
  tabElementShow(contentEl);
  tabElementShow(carouselEl);

  captionMore(
    $(contentEl).find($(tabCaptionEl)),
    $(contentEl).find($(tabCaptionInnerEl)),
    $(contentEl).find($(moreOuterEl)),
  );

  initCarousel(carouselEl, btnPrevEl, btnNextEl, scrollEl);

  return true;
});

$(document).on('click tap keyup', moreEl, (event) => {
  if (keyCodesAvailable.indexOf(event.keyCode) === -1) {
    return false;
  }

  $(tabCaptionEl).toggleClass('open');
  if ($(tabCaptionEl).hasClass('open')) {
    $('.tacc__more').text('Read less');
  } else {
    $('.tacc__more').text('Read more');
  }
  return true;
});

$(document).ready(() => {
  AdaSupport($(tabButtonEl));
});
